import { createEntryPoint } from '#packages/apilib';

import { SlotOpenerApiKey } from './publicApiKey';
import { SlotOpenerApi } from './publicApi';
import SlotOpenerLine from './components/slotOpenerLine';
import { SlotOpenerScope } from './scope';

export const SlotOpenerEntryPoint = createEntryPoint({
  name: 'SlotOpener',
  Scope: SlotOpenerScope,
  publicApi({ contributeApi }) {
    contributeApi(SlotOpenerApiKey, SlotOpenerApi);
  },

  initialize(scope) {
    scope.workspaceApi.contributeMouseCatcherComponent(SlotOpenerLine);
  },
});
